export default "__VITE_ASSET__CWEbEts$__"